import React, { useState } from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

const AccordionElement = (props) => {
  const [isOpen, setOpen] = useState(props.open);

  const toggleOpen = () => {
    props.openToggle(props.id);
    setOpen(!isOpen);
  };

  return (
    <div
      className={classNames({
        "accordion-wrapper": true,
        "--open": isOpen,
      })}
    >
      <div
        className={classNames({
          "accordion-title": true,
        })}
        onClick={toggleOpen}
      >
        <span className="text">{props.title_text}</span>
        <span className="arrow" />
      </div>
      <div
        className={classNames({
          "accordion-body": true,
        })}
      >
        <div className="content">{props.children}</div>
      </div>
    </div>
  );
};

AccordionElement.propTypes = {
  id: PropTypes.string.isRequired,
  title_text: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
};

export default AccordionElement;
